import * as React from "react";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import PlatformSidebar from "./PlatformSidebar";
import { shouldUsePlatformShell } from "./platformNavConfig";
import { platformColors, platformContentAreaSx } from "../tickitPlatformTheme";

function PlatformShell({ children, role }) {
  const { pathname } = useLocation();
  const useShell = shouldUsePlatformShell(pathname, role);

  if (!useShell) {
    return <>{children}</>;
  }

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        minHeight: `calc(100vh - 60px)`,
        bgcolor: platformColors.shellBg,
      }}
    >
      <PlatformSidebar />
      <Box component="main" id="main-content" className="platform-content-area" sx={platformContentAreaSx}>
        {children}
      </Box>
    </Box>
  );
}

const mapStateToProps = (state) => ({
  role: state?.auth?.token?.split(" ")[0],
});

export default connect(mapStateToProps)(PlatformShell);
